import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden", "aria-valuenow"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-progress", { active: _ctx.running, done: _ctx.finishing }]),
    role: "progressbar",
    "aria-label": "Chargement de la page",
    "aria-hidden": !_ctx.running,
    "aria-valuenow": Math.round(_ctx.progress * 100),
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, [
    _createElementVNode("div", {
      class: "ui-progress-bar",
      style: _normalizeStyle({ transform: `scaleX(${_ctx.progress})` })
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "ui-progress-glow" }, null, -1)
    ]), 4)
  ], 10, _hoisted_1))
}